import Phaser from 'phaser';
import { musicUp } from '../SoundManager';
import ABCyaPhaser from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import UIAssetKeys from '../UIAssetKeys';
import gameData from '../gameData';
import { dotPop, resizeDimensions } from '../Utils';
import Monster from '../characters/Monster';
import GameScreen from './GameScreen';
import Emitter from '../game/Emitter';
import SpritePool from '../common/SpritePool';
import CrumbSprite from '../characters/CrumbSprite';
import Hammer from 'hammerjs';
import SoundAssetKeys from '../SoundAssetKeys';
import RandomValuePool from '../common/RandomValuePool';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import FontKeys from '../FontKeys';
import LocalizationUIAssets from '../Localization-UIAssets';

export default class FinishedScreen extends Phaser.Scene {
  static get KEY() { return 'FinishedScreen'; }

  constructor() {
    super({ key: FinishedScreen.KEY });
  }

  create() {
    musicUp(this);

    ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._LandscapeMainBackground_4x3, this).setOrigin(0);

    this.sceneContainer = this.add.container();
    this.sceneContainer.y = 100;

    this.sceneX = 0;
    this.slideSpeed = 0;

    this.slidingItems = [];
    this.slideState = 0;

    this.pinkStripes = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._PinkStripes, this.sceneContainer).setOrigin(0);
    this.pinkStripes.scaleY = 470;
    this.pinkStripes.y = 0;
    this.pinkStripes2 = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._PinkStripes, this.sceneContainer).setOrigin(0);
    this.pinkStripes2.scaleY = 470;
    this.pinkStripes.x = this.scale.width;
    this.pinkStripes2.y = 0;

    this.createBgItems();

    const sprite = ABCyaPhaser.Images.addImage(0,470, UIAssetKeys._Front_Counter, this.sceneContainer).setOrigin(0);
    sprite.scaleX = this.scale.width;
    sprite.y = 470;
    const counterCenterY = 470 + 50;

    this.monster = new Monster(this);
    this.monster.x = 1270 + this.extraX;
    this.monster.y = 130;
    this.sceneContainer.add(this.monster);

    const trimmedCanvas = this.textures.get('trimmed');
    const scale = 0.2;
    const newwidth = Math.ceil(trimmedCanvas.width * scale);
    const newheight = Math.ceil(trimmedCanvas.height * scale);

    if (this.textures.exists('monstersicecream')) this.textures.remove('monstersicecream');
    this.monstersIceCreamCanvas = this.textures.createCanvas('monstersicecream', newwidth, newheight);
    this.monstersIceCreamCanvas.context.drawImage(trimmedCanvas.canvas, 0,0,newwidth,newheight);
    this.monstersIceCreamCanvas.refresh();
    this.monstersIceCream = new Phaser.GameObjects.Image(this,0,0,'monstersicecream').setOrigin(0.5, 1)
      .setInteractive({ draggable: true });
    this.mctx = this.monstersIceCreamCanvas.context;

    const savePic = this.textures.createCanvas(`savepic${gameData.picCollection.length}`, newwidth, newheight);
    savePic.context.drawImage(trimmedCanvas.canvas, 0,0,newwidth,newheight);
    savePic.refresh();
    savePic.picFrameType = Phaser.Math.Between(1,4);
    gameData.picCollection.push(savePic);

    this.mctx.globalCompositeOperation = 'destination-out';
    this.sceneContainer.add(this.monstersIceCream);
    this.monstersIceCream.x = this.monstersIceCream.width / 2 + 2;
    this.monstersIceCream.y = counterCenterY;

    this.biteMask = new Phaser.GameObjects.Image(this, 0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._BiteMask).setOrigin(0);
    this.biteY = 0;

    this.containerOverlay = null;
    if (gameData.containerDishName) {
      this.containerOverlay = new Phaser.GameObjects.Image(this,0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, gameData.containerDishName).setOrigin(0);
      this.containerOverlay.scale = scale;
      this.containerOverlay.y = this.monstersIceCream.y + this.monstersIceCream.height - (this.containerOverlay.height * scale);
    }

    this.armOver = this.add.container();
    this.monster.layerArm(this.armOver);
    this.sceneContainer.add(this.armOver);

    this.btnStartOver = this.add.container(this.scale.width / 2, this.scale.height / 2, [
      ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._BUTTON_StartOver_2, this).setInteractive()
        .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onNextClick, this),
      ABCyaPhaser.Text.addText(1,45,42, 0xffffff, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.start_over_button'), this).setOrigin(0.5, 0)
    ]).setAlpha(0)
      .setScale(0);
    this.btnStartOver.getAt(1).setLineSpacing(-15)
      .setWordWrapWidth(this.btnStartOver.getAt(0).width - 10);

    this.title = ABCyaPhaser.Text.addText(0,0,42, 0x009986, FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('end_screen.instructions'), this).setStroke('#ffffff', 2)
      .setWordWrapWidth(675);
    this.title.setPosition(this.scale.width / 2, 12 + this.title.height / 2);

    const sn = ABCyaLib.DEVICE_INFO.desktop ? UIAssetKeys._Mouse_Pointer : UIAssetKeys._Hand_Pointer;
    this.helperHand = ABCyaPhaser.Images.addImage(-1111, 0, sn, this).setOrigin(0)
      .setAlpha(0);

    const pos = ABCyaPhaser.GameObjects.getScreenPosition(this.monster.mouth);
    this.mouthPos = { x: pos.x - this.monster.x + (this.monster.x - this.lastItemX),y: pos.y + 23 };

    const pcount = 80;
    this.crumbEmitter = new Emitter(this, this.mouthPos, 1, 100);
    this.particlePool = new SpritePool(CrumbSprite, pcount, this);

    /** @type {CrumbSprite[]} */
    this.particles = [];

    this.hammertime = new Hammer(document.getElementById('contentWrapper'));
    this.hammertime.add(new Hammer.Pan({ threshold: 3 }));
    this.hammerListener = this.hammertime.on('panleft panright', this.handleHammerGesture.bind(this));

    this.monstersIceCream.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleIcecreamDown, this);
    this.monstersIceCream.on(Phaser.Input.Events.GAMEOBJECT_DRAG, this.handleIcecreamDrag, this);
    this.monstersIceCream.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, this.handleIcecreamUp, this);
    this.grabbingIcecream = false;
    this.grabMinX = this.monstersIceCream.x;
    this.grabMaxX = this.monstersIceCream.x + 100;
    this.lastSwipeVX = 0;
    this.slideStopX = 570 + this.monstersIceCream.width / 2;

    this.setupMonsterMess();

    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._Slide_Down_Counter, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.startIntro();
  }

  createBgItems () {
    let sprite = null;
    let x = 0;
    const y = 0;

    let flagCount = 5;
    if (gameData.picCollection.length > 0) {
      const amt = gameData.picCollection.length / 4;
      Math.round(amt);
      flagCount += amt;
    }
    for (let i = 0; i < flagCount; i++) {
      sprite = this.addSlideSprite(UIAssetKeys._BG_Flags, x, y);
      x += sprite.width + 10;
    }

    x = this.scale.width - 800;
    sprite = this.addSlideSprite(UIAssetKeys._BG_ITEM_1, 100, 100);
    sprite = this.addSlideSprite(LocalizationUIAssets._BG_ITEM_2, 600 + x, 82, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    sprite = this.addSlideSprite(UIAssetKeys._BG_ITEM_3, 846 + x, 26);
    sprite = this.addSlideSprite(UIAssetKeys._BG_ITEM_4, 846 + x, 213);
    sprite = this.addSlideSprite(UIAssetKeys._BG_ITEM_5, 1120 + x, 42);
    sprite = this.addSlideSprite(UIAssetKeys._BG_ITEM_6, 1370 + x, 42);

    this.lastItemX = sprite.x + sprite.width - this.scale.width + 160;

    const picCount = gameData.picCollection.length;
    let item = null;
    let frame = null;
    let startX = sprite.x + sprite.width + 70;
    this.extraX = 0;
    for (let i = 0; i < picCount; i++) {
      const picCanvas = gameData.picCollection[i];
      const pic = new Phaser.GameObjects.Image(this, 0,0,picCanvas.key).setOrigin(0);
      item = this.add.container();
      frame = ABCyaPhaser.Images.addImage(0,0,`PicFrame+${picCanvas.picFrameType}`,this).setOrigin(0);

      const scale = resizeDimensions(pic.width, pic.height, frame.width - 16 * 2, frame.height - 16 * 2);
      pic.scale = scale.scale;
      pic.x = frame.width / 2 - pic.width / 2 * pic.scaleX;
      pic.y = frame.height / 2 - pic.height / 2 * pic.scaleY;
      item.add([frame, pic]);
      item.x = startX;
      this.slidingItems.push(item);
      this.sceneContainer.add(item);

      if (i % 2 === 0) {
        this.extraX += frame.width + 70;
        item.y = 26;
      }
      else {
        item.y = 213;
        startX += frame.width + 50;
      }
    }

    this.lastItemX += this.extraX;

    // counter
    sprite = this.addSlideSprite(UIAssetKeys._BG_ITEM_77, 0, 312);
  }

  addSlideSprite (sn, x, y, atlas = ABCyaPhaser.Images.DEFAULT_ATLAS) {
    const sprite = ABCyaPhaser.Images.addImage(x, y, sn, this.sceneContainer, atlas).setOrigin(0);
    this.slidingItems.push(sprite);
    return sprite;
  }

  onNextClick () {
    gameData.userImage = null;
    this.nextScene();
  }

  nextScene () {
    this.destroy();
    this.scene.start(GameScreen.KEY);
  }

  destroy () {
    this.bg = null;

    this.hammertime.destroy();
    this.tweens.killAll();
  }

  handleHammerGesture (e) {
    switch (e.type) {
      case 'panleft':
        this.lastSwipeVX = e.velocityX;
        break;
      case 'panright':
        this.lastSwipeVX = e.velocityX;
        break;
    }
  }

  handleIcecreamDown (pointer) {
    if (this.slideState !== 0) return;

    this.monstersIceCream.dragOffsetX = this.monstersIceCream.x - pointer.x;
    this.monstersIceCream.dragOffsetY = this.monstersIceCream.y - pointer.y;
    this.grabbingIcecream = true;
    this.stopIntro();
  }

  stopIntro () {
    this.tweens.killTweensOf(this.helperHand);
    this.helperHand.visible = false;
  }

  handleIcecreamDrag (pointer) {
    if (this.slideState !== 0) return;

    let x = pointer.x + this.monstersIceCream.dragOffsetX;
    if (x < this.grabMinX) {
      x = this.grabMinX;
    }
    else if (x > this.grabMaxX) {
      x = this.grabMaxX;
    }
    this.monstersIceCream.x = x;
  }

  handleIcecreamUp () {
    if (this.slideState !== 0) return;

    this.grabbingIcecream = false;
    if (this.lastSwipeVX >= 0) {
      this.title.visible = false;
      this.tweens.killTweensOf(this.title);
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._slide_long, this);
      this.beginSlide(-5.375 * -1);
    }
  }

  beginSlide (boostMod) {
    this.slideSpeed = 400 + (boostMod * 162);
    this.slideState = 1;
  }

  setupMonsterMess () {
    this.currentLayer = 0;
    this.halfWay = this.monstersIceCream.height * 0.4;
    const info = gameData.sundayInfo;

    this.layers = [];

    let li = null;
    const layerCount = info.layerInfo.length;
    let theLayer = null;
    for (let l = layerCount - 1; l >= 0; l--) {
      theLayer = info.layerInfo[l];
      li = { flavor: theLayer.flavor, crumbNames: [] };
      let cnt = 0;
      cnt = theLayer.sauces.length;
      for (let z = 0; z < cnt; z++) {
        if (theLayer.sauces[z] > 0) {
          li.crumbNames.push(`CrumbSauce+${z + 1}`);
        }
      }
      cnt = theLayer.whippedcreams.length;
      for (let z = 0; z < cnt; z++) {
        if (theLayer.whippedcreams[z] > 0) {
          li.crumbNames.push(`CrumbCream+${z + 1}`);
        }
      }
      cnt = theLayer.toppings.length;
      const tppingTypesUgh = [5,5, 1, 1, 1];
      for (let z = 0; z < cnt; z++) {
        if (z === 3) {
          console.log('skip cherries');
          continue;
        }
        if (theLayer.toppings[z] > 0) {
          for (let ugh = 0; ugh < tppingTypesUgh[z]; ugh++) {
            li.crumbNames.push(`CrumbTopping+${z + 1}+${ugh + 1}`);
          }
        }
      }
      this.layers.push(li);
    }

    this.currentLayer = 0;
    this.crumbNamePool = new RandomValuePool(this.layers[this.currentLayer].crumbNames);
  }

  startIntro () {
    this.title.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.title, 400, { alpha: 1 }, Phaser.Math.Easing.Linear);

    this.helperHand.x = this.monstersIceCream.x - 20;
    const x = this.helperHand.x;
    this.helperHand.y = this.monstersIceCream.y - this.monstersIceCream.height / 2;
    this.helperHand.alpha = 0;
    this.helperHand.scale = 1.1;

    const getPowIn = function(pow) {
      return function(t) {
        return Math.pow(t,pow);
      };
    };

    ABCyaPhaser.Tweens.addTween(this.helperHand, 500, { delay: 440, alpha: 1, scale: 1 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, 1200, { delay: 80, x: x + 160 },getPowIn(7), () => {
        ABCyaPhaser.Tweens.addTween(this.helperHand, 200, { x: x + 200, alpha: 0, scale: 1.1 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.helperHand.x = x;
          ABCyaPhaser.Tweens.addTween(this.helperHand, 500, { delay: 330, alpha: 1, scale: 1 }, Phaser.Math.Easing.Linear, () => {
            ABCyaPhaser.Tweens.addTween(this.helperHand, 1200, { delay: 80, x: x + 180 }, getPowIn(7), () => {
              ABCyaPhaser.Tweens.addTween(this.helperHand, 200, { x: x + 200, alpha: 0, scale: 1.1, completeDelay: 3200 }, Phaser.Math.Easing.Quadratic.Out, () => {
                this.showSlideHelper();
              });
            });
          });
        });
      });
    });
  }

  showSlideHelper () {
    this.helperHand.x = this.monstersIceCream.x - 20;
    const x = this.helperHand.x;
    this.helperHand.y = this.monstersIceCream.y;
    this.helperHand.alpha = 0;

    const getPowIn = function(pow) {
      return function(t) {
        return Math.pow(t,pow);
      };
    };

    ABCyaPhaser.Tweens.addTween(this.helperHand, 500, { delay: 440, alpha: 1, scale: 1 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(this.helperHand, 1200, { delay: 80, x: x + 160 }, getPowIn(7), () => {
        ABCyaPhaser.Tweens.addTween(this.helperHand, 200, { x: x + 200, alpha: 0, scale: 1.1, completeDelay: 3200 }, Phaser.Math.Easing.Quadratic.Out, () => {
          this.showSlideHelper();
        });
      });
    });
  }

  slideUpdate (dt) {
    const speed = this.slideSpeed * dt;
    this.sceneX += speed;
    if (this.sceneX < this.lastItemX) {
      this.updateSlideSprites(-speed);

      this.monster.x -= speed;
      this.armOver.x = this.monster.x;
      this.pinkStripes.x -= speed;
      this.pinkStripes2.x -= speed;
      if (this.pinkStripes2.x <= -this.scale.width) {
        this.pinkStripes2.x = this.pinkStripes.x + this.scale.width;
      }
      if (this.pinkStripes.x <= -this.scale.width) {
        this.pinkStripes.x = this.pinkStripes2.x + this.scale.width;
      }
    }
    else {
      this.monstersIceCream.x += speed;
      if (this.monstersIceCream.x > this.slideStopX) {
        this.monstersIceCream.x = this.slideStopX;
        this.slideState = 3;
      }
      else {
        this.slideSpeed *= 0.98916;
        if (this.slideSpeed < 283) this.slideSpeed = 283;
      }
    }
  }

  updateSlideSprites (howmuch) {
    const len = this.slidingItems.length;
    for (let i = 0; i < len; i++) {
      this.slidingItems[i].x += howmuch;
    }
  }

  startMonsterEating () {
    this.biteCount = 0;
    this.monstersIceCream.restingX = this.monstersIceCream.x;
    this.monstersIceCream.restingY = this.monstersIceCream.y;
    this.monster.setEatType(this.containerOverlay !== null);

    const oooJoe = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    oooJoe.once(Phaser.Sound.Events.COMPLETE, () => oooJoe.destroy());
    if (oooJoe) {
      this.monster.sayOooh();
      oooJoe.once(Phaser.Sound.Events.COMPLETE, this.chompAway, this);
    }
    else {
      this.chompAway();
    }
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._Ooooo_Ice_Cream, oooJoe);
  }

  chompAway () {
    this.monster.takeBite(true);
  }

  takeOutBite () {
    const biteSize = 20;
    let intoCone = false;
    this.moveConeForBite();

    const image = this.biteMask.frame.source.image;
    const sr = this.biteMask.frame.canvasData;
    this.mctx.drawImage(image, sr.x, sr.y, sr.width, sr.height, 0, this.biteY,this.monstersIceCream.width, this.biteMask.height);
    this.monstersIceCreamCanvas.refresh();
    if (this.biteY >= this.monstersIceCream.height - biteSize * 2) {
      this.monster.isEating = false;
      this.monster.burp(1150);
      dotPop(this.btnStartOver, 600, 1200);
      this.bg = this.add.rectangle(0,0,this.scale.width, this.scale.height, 0x000000).setAlpha(0)
        .setOrigin(0);
      this.children.bringToTop(this.btnStartOver);
      ABCyaPhaser.Tweens.addTween(this.bg, 900, { delay: 900, alpha: 0.6 }, Phaser.Math.Easing.Quadratic.In);
    }
    else {
      if (Phaser.Math.Between(1,100) > 44) {
        this.monster.addSplash(this.layers[this.currentLayer].flavor);
      }
      if (this.biteY >= this.halfWay) {
        if (this.containerOverlay === null) {
          intoCone = true;
        }
        if (this.currentLayer < this.layers.length - 1) {
          this.currentLayer = this.layers.length - 1;
          this.crumbNamePool = new RandomValuePool(this.layers[this.currentLayer].crumbNames);
        }
      }
    }

    this.makeCrumbs(8, intoCone);

    this.biteY += biteSize;
    this.biteCount++;

    return this.biteCount;
  }

  moveConeForBite () {
    if (this.containerOverlay) return;
    this.monstersIceCream.x = 600;
    this.monstersIceCream.y = 470 - this.biteY / 2;
    this.monstersIceCream.angle = 10 + this.biteCount;
  }

  monsterArmDown () {
    if (this.containerOverlay) return;
    this.monstersIceCream.x = this.monstersIceCream.restingX;
    this.monstersIceCream.y = this.monstersIceCream.restingY;
    this.monstersIceCream.angle = 0;
  }

  makeCrumbs (count, doCone = false) {
    /** @type {CrumbSprite} */
    let particle = null;
    let props = null;
    const bCount = count || 1;

    for (let i = 0; i < bCount; i++) {
      for (let j = 0; j < this.crumbEmitter.rate; j++) {
        particle = this.particlePool.getSprite();
        if (particle === null) return;
        props = this.crumbEmitter.emitParticle();

        let sn = `SplashPart+${this.layers[this.currentLayer].flavor}`;
        const r1 = Phaser.Math.Between(1,20);
        if (r1 <= 5) {
          sn = this.crumbNamePool.getValue();
        }
        else if (r1 < 10 && doCone) {
          sn = 'ConeCrumb';
        }
        if (sn) {
          particle.reset(props.position, props.velocity, props.lifetime, sn);
          this.particles.push(particle);
          this.add.existing(particle);
        }
      }
    }
  }

  alignContainer () {
    if (this.containerOverlay) {
      this.containerOverlay.x = this.monstersIceCream.x - this.containerOverlay.width / 2 * this.containerOverlay.scaleX;
      this.containerOverlay.y = this.monstersIceCream.y - this.containerOverlay.height * this.containerOverlay.scaleY;
    }
  }

  returnCrumb (i) {
    const p = this.particles[i];
    this.children.remove(p);
    this.particlePool.returnSprite(p);
    this.particles.splice(i,1);
  }

  update (time, delta) {
    const dt = delta / 1000;

    if (this.slideState === 1) {
      this.slideUpdate(dt);
    }
    else if (this.slideState === 3) {
      this.slideState = 4;
      this.monstersIceCream.x = this.slideStopX;
      this.startMonsterEating();
    }
    else if (this.slideState === 4) {
      if (this.containerOverlay) {
        this.alignContainer();
        this.sceneContainer.add([this.containerOverlay, this.armOver]);
        this.sceneContainer.bringToTop(this.containerOverlay);
        this.sceneContainer.bringToTop(this.armOver);
      }
      this.monster.tick(dt);
    }

    const len = this.particles.length - 1;
    for (let i = len; i >= 0; i--) {
      const particle = this.particles[i];
      const alive = particle.tick(dt);
      if (alive === false) {
        this.returnCrumb(i);
      }
      else {
        particle.update();
      }
    }
  }
}